// Utility function to load documentation resources dynamically
export const loadDocumentationResources = (documentationHost: string) => {
  // Load CSS files
  const cssFiles = [
    '/documentation-styles/help-center-xisDocStyle-00.css',
    '/documentation-styles/prism-sas.css'
  ];

  cssFiles.forEach(cssFile => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = documentationHost + cssFile;
    document.head.appendChild(link);
  });

  // Load JS files
  const jsFiles = [
    '/documentation-styles/prism.js'
  ];

  jsFiles.forEach(jsFile => {
    const script = document.createElement('script');
    script.src = documentationHost + jsFile;
    document.head.appendChild(script);
  });
};